import { render, staticRenderFns } from "./personaje-icon-1.vue?vue&type=template&id=b5c80eee&scoped=true&"
import script from "./personaje-icon-1.vue?vue&type=script&lang=js&"
export * from "./personaje-icon-1.vue?vue&type=script&lang=js&"
import style0 from "./personaje-icon-1.vue?vue&type=style&index=0&id=b5c80eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c80eee",
  null
  
)

export default component.exports